import { BagPersonalOutlineIcon } from './BagPersonalOutlineIcon';

/**
 * author: Michael Richins
 * id E95F21EF-993D-462F-BA6E-21F7665BC34C
 * name bag-personal-outline
 * version: 3.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bag-personal-outline.svg
 * tags
 * - Transportation + Flying 
 */
export const BackpackOutlineIcon = BagPersonalOutlineIcon;
export default BackpackOutlineIcon